<button mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)='createIncident()'>
    <mat-icon>add</mat-icon>
    <span>Create Incident</span>
  </button>
</mat-menu>
